import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { DotText } from "@/v2-backoffice-client/components/dot"

export type SelectorItemTextProps = ComponentProps<"div"> & {
  isRemoved?: boolean
  primary: string
  secondary?: string | null | undefined
}

function SelectorItemText(props: SelectorItemTextProps) {
  const { isRemoved, primary, secondary, className, ...divProps } = props

  return (
    <div className={cn("selector-item-text", className)} {...divProps}>
      <span className="selector-item-primary">{primary}</span>
      {isRemoved && (
        <DotText variant="destructive" className="selector-item-removed">
          Removed
        </DotText>
      )}
      {secondary && (
        <span className="selector-item-secondary">{secondary}</span>
      )}
    </div>
  )
}

export default SelectorItemText
